import type { FieldTemplateProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const FieldTemplate = (rest: FieldTemplateProps) => {
  const {
    id,
    children,
    description,
    displayLabel,
    help,
    hidden,
    label,
    rawDescription,
    rawErrors,
    schema,
    uiSchema
  } = rest
  const showLabel = displayLabel === true || uiSchema?.['ui:label'] === true
  const className = `basis-2/5 grow w-full ${uiSchema?.['ui:classNames'] || ''}`
  const props = {
    id: `${id}_field`,
    className,
    hidden
  }
  const desc = showLabel && !!rawDescription?.length && description
  const errors = rawErrors?.map((errorMessage) => (
    <Mtds.Validation key={`${id}-${errorMessage}`}>
      {errorMessage}
    </Mtds.Validation>
  ))

  if (id === 'root') return children // Skip rendering the root element as Field to avoid nesting
  if (Array.isArray(uiSchema?.['ui:order'])) return children // Skip rendering the root element if group of Fields
  const isCompositeField =
    schema.type === 'object' ||
    schema.type === 'array' ||
    uiSchema?.['ui:widget'] === 'radio' ||
    uiSchema?.['ui:widget'] === 'markdownEditorWidget'

  if (isCompositeField)
    return (
      <Mtds.Fieldset {...props}>
        <legend hidden={!showLabel}>{label}</legend>
        {desc}
        {children}
        {errors}
        {help}
      </Mtds.Fieldset>
    )
  return (
    <Mtds.Field {...props}>
      <label hidden={!showLabel}>{label}</label>
      {desc}
      {children}
      {errors}
      {help}
    </Mtds.Field>
  )
}
